import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';
import { recordPageView } from '@/components/dashboard/RealtimeAnalyticsWidget';

export function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
    recordPageView(location.pathname);
  }, [location.pathname]);

  return null;
}
